<template>
  <div>
    <b-form-group label="Nome Fantasia:">
      <b-form-input
        v-model="pessoa_juridica.nome"
        placeholder="Nome"
        :state="validateState('nome')"
      ></b-form-input>
      <b-form-invalid-feedback
        >Nome é um campo obrigatório.</b-form-invalid-feedback
      >
    </b-form-group>

    <b-form-group label="Razão Social:">
      <b-form-input
        v-model="pessoa_juridica.razao_social"
        placeholder="Razão Social"
        :state="validateState('razao_social')"
      ></b-form-input>
      <b-form-invalid-feedback
        >Razão Social é um campo obrigatório.</b-form-invalid-feedback
      >
    </b-form-group>

    <b-form-group label="CNPJ:">
      <b-form-input
        v-model="cnpj"
        placeholder="CNPJ"
        :state="validateState('cnpj')"
      ></b-form-input>
      <b-form-invalid-feedback>
        <span v-if="!$v.pessoa_juridica.cnpj.required"
          >CNPJ é um campo obrigatório.</span
        >
        <span v-if="!$v.pessoa_juridica.cnpj.cnpj">CNPJ inválido</span>
        <span v-if="!$v.pessoa_juridica.cnpj.is_unique"
          >CNPJ já está em uso por outra pessoa jurídica</span
        >
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group label="Inscrição Estadual:">
      <b-form-input
        v-model="pessoa_juridica.ie"
        placeholder="IE"
      ></b-form-input>
    </b-form-group>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { cnpj } from "cpf-cnpj-validator";
import { mapState } from "vuex";
import { mask } from "vue-the-mask";

export default {
  props: {
    cnpj_invalid: {
      default: null,
    },
  },
  mixins: [validationMixin],
  data: () => ({}),
  validations: {
    pessoa_juridica: {
      razao_social: {
        required,
        minLength: minLength(3),
      },
      nome: {
        required,
        minLength: minLength(3),
      },
      cnpj: {
        cnpj: (value) => {
          return !value || cnpj.isValid(value);
        },
        is_unique(value) {
          return value != this.cnpj_invalid;
        },
      },
    },
  },
  computed: {
    ...mapState("pessoas_juridica", ["pessoa_juridica"]),

    cnpj: {
      set(value) {
        value = value.replace(/\D/g, "").substring(0, 14);
        this.pessoa_juridica.cnpj = value;
      },
      get() {
        let value = this.pessoa_juridica.cnpj;
        if (!value) {
          value = "";
        }

        value = value.replace(
          /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
          "$1.$2.$3/$4-$5"
        );

        return value;
      },
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.pessoa_juridica[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      this.$v.pessoa_juridica.$touch();
      return !this.$v.pessoa_juridica.$anyError;
    },
    formatterCnpj(value) {
      value = value.replace(/\D/g, "").substring(0, 14);
      value = value.replace(
        /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
        "$1.$2.$3/$4-$5"
      );
      return value;
    },
  },
  created() {},
  directives: { mask },
};
</script>
